import { organizationEntityName } from '../../../../backend/features/organizations/shared';
import { useStorageGet } from '@juvare/platform-sdk-react/ui/hooks';
export function useOrganization(id) {
    return useStorageGet(organizationEntityName, id);
}
